"use client";
import React from "react";
import { PortableText } from "@portabletext/react";
import { cn } from "../../lib/utils";
import { urlFor } from "../../sanity/lib/image";
import Image from "next/image";

const serializers = {
  types: {
    // @ts-ignore
    image: ({ value }) => {
      // we need to get the image source url, and since @sanity/image-url will give us optimised images for each instance we use it
      const imgUrl = urlFor(value.asset)?.url() || "";

      return (
        <div
          className={cn(
            "w-full flex justify-center items-center my-4 relative",
            value.aspectRatio
          )}
          style={{
            minHeight: value.height || 150,
          }}
        >
          <Image
            fill
            alt={value.alt}
            src={imgUrl}
            sizes="100vw"
            className={cn("not-prose", value.objectFit, value.objectPosition)}
            // priority={false}
          />
        </div>
      );
    },
  },
};

export interface ContentBlockProps {
  blocks: any[];
}

export default function BlockContent(props: ContentBlockProps) {
  return (
    <div className="w-full prose">
      <PortableText value={props.blocks} components={serializers} />
    </div>
  );
}
